import { createContext, useEffect, useRef, useState } from "react"
import RootFrame from "./components/RootFrame"
import Router from './routes/Router'

import MessageDlg from './components/MessageDialog'
import { useDisclosure } from "@chakra-ui/react"

export const SiteContext =createContext()
export const useSyncState = (initValue) => {
  const ref = useRef(initValue)
  const state =useState(initValue)
  // ref.current = initValue

  function setValue(value) {
    ref.current = value
    state[1](value)
  }

  return [state[0], setValue, ref]
}

var Root =({})=>{
  const fontRef =useRef(null)
  const directionState =useSyncState(0)
  const isPortraitMode =useSyncState(false)
  const msgDlgDisclosure =useDisclosure()

  const msgDlgState =useSyncState({
    disclosure: msgDlgDisclosure,
    title: '[TITLE]',
    context: '[DLG-CONTEXT]<br/>[DLG-CONTEXT]',
    onConfirm: ()=>{
      msgDlgDisclosure.onClose()
    },
    onCancel: undefined,
    showCancelBtn: false,
  })
  msgDlgDisclosure._onOpenImpl =msgDlgDisclosure.onOpen
  msgDlgDisclosure.onOpen =()=>{
    msgDlgDisclosure._onOpenImpl()
    msgDlgDisclosure.isOpen =true

    msgDlgState[1]({
      ...msgDlgState[2].current,
      disclosure: msgDlgDisclosure,
    })
  }
  msgDlgDisclosure._onCloseImpl =msgDlgDisclosure.onClose
  msgDlgDisclosure.onClose =()=>{
    msgDlgDisclosure._onCloseImpl()
    msgDlgDisclosure.isOpen =false

    msgDlgState[1]({
      ...msgDlgState[2].current,
      disclosure: msgDlgDisclosure,
    })
  }

  // //To stop the touch event from being passed to the webview
  // var interceptTouchMove =(e)=>{
  //   e.preventDefault()
  // }
  // useEffect(()=>{
  //   window.addEventListener("touchmove", interceptTouchMove, {passive: false});
  //   return ()=>{
  //     window.removeEventListener('touchmove', interceptTouchMove)
  //   }
  // },[])

  useEffect(()=>{

    if ('ontouchstart' in document.documentElement) {
      console.log('244 - modify css rule from :hover --> :active')

      const styleSheets = Array.from(document.styleSheets).filter(
        (styleSheet) => !styleSheet.href || styleSheet.href.startsWith(window.location.origin)
      )
      for (let sheet of styleSheets) {
        if (sheet instanceof CSSStyleSheet && sheet.cssRules) {
          
          for (var ruleI = sheet.cssRules.length - 1; ruleI >= 0; ruleI--) {
            var rule = sheet.cssRules[ruleI];

            if (rule.selectorText) {
              rule.selectorText = rule.selectorText.replace(':hover', ':active');
            }
          }

        }
      }

      console.log('259 - add disableClass to body element')
      document.body.classList.add("disableSelect")
    }
    
    handleResize(true)
    window.addEventListener('resize', handleResize)
    return ()=>{
      window.removeEventListener('resize', handleResize)
    }
  },[])

  var handleResize =(force_run)=>{

    const size =window.getComputedStyle(fontRef.current, null).getPropertyValue('font-size')
    const scale =16/parseFloat(size);
    
    let vh =document.documentElement.clientHeight * 0.01
    var font_vh =vh * scale
    var font_vw =document.documentElement.clientWidth * 0.01 * scale
    document.documentElement.style.setProperty('--vh', `${vh}px`)
    document.documentElement.style.setProperty('--fvh', `${font_vh}px`)
    document.documentElement.style.setProperty('--fvw', `${font_vw}px`)

    // var width =Math.min(document.documentElement.clientWidth, 492/1136*document.documentElement.clientHeight)
    var width =492/1136*document.documentElement.clientHeight
    // setDrawerWidth(width)

    isPortraitMode[1](document.documentElement.clientHeight>document.documentElement.clientWidth)
    
  }

  return (
    <>
      <span ref={fontRef}/>
      <SiteContext.Provider value={[directionState, isPortraitMode, msgDlgState]}>
        <RootFrame>
          <Router.RouteRoot/>
        </RootFrame>
      </SiteContext.Provider>
      <MessageDlg 
        disclosure={msgDlgDisclosure} 
        title={msgDlgState[2].current.title} 
        cxt={msgDlgState[2].current.context} 
        onConfirm={msgDlgState[2].current.onConfirm} 
        showCancelBtn={msgDlgState[2].current.showCancelBtn}
        onCancel={msgDlgState[2].current.onCancel}
      />
    </>
  )
}

export default Root